import React, { useEffect } from "react";
import { getCuentas } from "../../../../app/store/actions/cuentaActions";
import { connect } from "react-redux";
import CuentaDashboard from "./CuentaDashboard";
import PropTypes from "prop-types";
import LoadingComponent from "../../../../app/layout/LoadingComponent";

const mapState = (state) => ({
  cuentas: state.cuentaReducer.cuentas,
  loading: state.cuentaReducer.loadingCuentas,
  currentUser: state.auth.currentUser,
});

const actions = {
  getCuentas,
};
const CuentaPage = ({ cuentas, loading, getCuentas, currentUser }) => {
  useEffect(() => {
    if (currentUser?.username) {
      getCuentas();
    }
  }, [getCuentas, currentUser]);

  if (!currentUser) {
    return <LoadingComponent content="Cargando usuario..." />;
  }

  if (loading) return <LoadingComponent content="Cargando cuentas..." />;
  return (
    <>
      <CuentaDashboard cuentas={cuentas} />
    </>
  );
};

CuentaPage.propTypes = {
  cuentas: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  getCuentas: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
};

export default connect(mapState, actions)(CuentaPage);
